exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-header[data-v-3f7e5837] {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 55px;\n    z-index: 2; /* Opcjonalne: Jeśli masz inne elementy z wyższym z-index, aby nagłówki były na wierzchu */\n}\n/* Po przypieciu kolumn table-layout.js wklada tabele w kontener z przewijaniem poziomym - on staje sie\n   wtedy odniesieniem dla sticky i top przesuwal naglowek w dol pod pierwszy wiersz. Przyklejony naglowek\n   zapewnia wtedy kopia z table-layout.js (.table-sticky-head), a przypiete kolumny trzymaja sie w poziomie. */\n.table-hscroll .sticky-header[data-v-3f7e5837] {\n    top: auto;\n}\n", ""]);

// exports
